import React from 'react';

import Razorpay from './razorpay/Razorpay';
import Stripe from './stripe/Stripe';

export default ({ paymentOrder }) => {
  return (
    <div style={{ marginTop: 20, marginBottom: 15 }}>
      {
        paymentOrder.mode === 'razorpay'
          ? <Razorpay paymentOrder={paymentOrder} />
          : <Stripe paymentOrder={paymentOrder} />
      }
    </div>
  );
};
